<div class="row">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Cognome e nome'"
		[valueInput]="(controparte.parte.cognome ? controparte.parte.cognome : '')+(controparte.parte.nome ? (' ' + controparte.parte.nome) : '')"></div>
	<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo persona'"
		[valueInput]="controparte.parte.tipoPersona?.label"></div>
	<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'boolean'"
		[labelInput]="'Dipendente'"
		[valueInput]="controparte.parte?.dipendente"></div>
	<!--<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Matricola'" [valueInput]="controparte.parte?.matricola"></div>-->
	<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Codice fiscale'"
		[valueInput]="controparte.parte?.codiceFiscale"></div>
</div>
<div class="row">
	<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Ragione Sociale'"
		[valueInput]="controparte.parte?.ragioneSociale"></div>
	<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Partita Iva'"
		[valueInput]="controparte.parte?.partitaIva"></div>
	<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
		[labelInput]="'CF Rappresentante legale'"
		[valueInput]="controparte.parte?.codiceFiscaleRappresentanteLegale"></div>
	<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'text'"
		[labelInput]="'Tipo societ&agrave;'"
		[valueInput]="controparte.parte.tipoSocieta?.label"></div>
</div>

<div class="row container_fieldset" *ngIf="!hideOtherData">
	<fieldset class="form-group">
		<legend>Nascita<span class="sr-only"> controparte</span></legend>
		<div labelTextInput class="col-sm-2 bloccodati" [typeLabel]="'date'"
			[labelInput]="'Data'" [valueInput]="controparte.parte?.dataNascita"></div>
		<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Comune'"
			[valueInput]="controparte.parte.comuneNascita?.label"></div>
		<div labelTextInput class="col-sm-5 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Provincia'"
			[valueInput]="controparte.parte.provinciaNascita?.label"></div>
	</fieldset>
</div>

<div class="row container_fieldset" *ngIf="!hideOtherData">
	<fieldset class="form-group">
		<legend>Residenza<span class="sr-only"> controparte</span></legend>
		<div labelTextInput class="col-sm-8 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Indirizzo'" [valueInput]="controparte.parte?.indirizzo"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cap'" [valueInput]="controparte.parte?.cap"></div>
		<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Comune'"
			[valueInput]="controparte.parte.comuneResidenza?.label"></div>
		<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Provincia'"
			[valueInput]="controparte.parte.provinciaResidenza?.label"></div>
	</fieldset>
</div>

<div class="row container_fieldset" *ngIf="!hideOtherData">
	<fieldset class="form-group">
		<legend>Contatti<span class="sr-only">controparte</span></legend>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Telefono'" [valueInput]="controparte.parte.telefono"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Cellulare'" [valueInput]="controparte.parte.cellulare"></div>
		<div labelTextInput class="col-sm-4 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Fax'" [valueInput]="controparte.parte.fax"></div>
		<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Email'" [valueInput]="controparte.parte.email"></div>
		<div labelTextInput class="col-sm-6 bloccodati" [typeLabel]="'text'"
			[labelInput]="'Pec'" [valueInput]="controparte.parte.pec"></div>
	</fieldset>
</div>
<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ controparte.parte.note }}</span>
    </p>
  </div>
<!-- 				<div labelTextInput class="col-sm-12 bloccodati" -->
<!-- 					[typeLabel]="'text'" [labelInput]="'Note'" -->
<!-- 					[valueInput]="controparte.parte.note"></div> -->
</div>
